import { sendEventToGTM } from '@neptune/analytics-domain';
import { ProjectWithRole } from '@neptune/shared/core-project-domain';

type UseProjectMetadataDetailsViewEvent = {
  senderUsername: string;
  project: ProjectWithRole | undefined;
};

export const useProjectMetadataDetailsViewEvent = ({
  senderUsername,
  project,
}: UseProjectMetadataDetailsViewEvent) => {
  return {
    sendMetadataDetailsViewEvent: () => {
      if (project) {
        sendEventToGTM({
          eventName: 'project_metadata_details_viewed_event',
          senderUsername,
          attributes: {
            projectName: project?.name,
            projectRole: project?.userRoleInProject,
            organizationName: project?.organizationName,
          },
        });
      }
    },
  };
};
